export const resourceMap = {
    navigator: 'B2BSSO_Nav',
    ipipeline: 'B2BSSO_iPipelineQuotes',
    igoeapp: 'B2BSSO_iGoeApp',
    carrierforms: 'B2BSSO_CarrierForms',
    carrierunderwriting: 'B2BSSO_CarrierUnderwriting',
    surelc: 'B2BSSO_SureLC',
    quilityu: 'B2BSSO_QuilityU',
    winflex: 'B2BSSO_Winflex',
    fequoter: 'B2BSSO_FEQuoter',
    switchboard: 'B2BSSO_Switchboard',
    marketingresourcelibrary: 'B2BSSO_MRL',
    reporthqissue: 'B2BSSO_ReportHQIssue',
};
